import { render, staticRenderFns } from "./ErrorComponent.vue?vue&type=template&id=59c496ed&scoped=true&"
import script from "./ErrorComponent.vue?vue&type=script&lang=js&"
export * from "./ErrorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c496ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59c496ed')) {
      api.createRecord('59c496ed', component.options)
    } else {
      api.reload('59c496ed', component.options)
    }
    module.hot.accept("./ErrorComponent.vue?vue&type=template&id=59c496ed&scoped=true&", function () {
      api.rerender('59c496ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Includes/ErrorComponent/ErrorComponent.vue"
export default component.exports